import React, { memo, useEffect, useMemo, useState } from "react";

import Cron from "react-js-cron";

import "react-js-cron/dist/styles.css";

import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import Switch from "../../../Common/Switch";
import { convertTimezone } from "../../../../util/common";

const Scheduler = ({ scheduleEnabled, cronValue, dispatchValues, toggleValue, timeZone, nextRunTime }) => {
  const [closeSelect, setCloseSelect] = useState(false);

  const nextRunDisplay = useMemo(
    () => (nextRunTime ? `Next Job run time: ${convertTimezone(nextRunTime)}` : ``),
    [nextRunTime]
  );

  // Code for solving floating select Issue
  useEffect(() => {
    document.getElementById("main_box").onscroll = () => {
      setCloseSelect(true);
      setCloseSelect(false);
    };
  }, []);

  return (
    <Grid container direction="row" spacing={0}>
      <Grid justifyContent="flex-start" display="flex" size={6}>
        <FormControl className="switch" component="fieldset">
          <FormGroup aria-label="position" row>
            <FormControlLabel
              value={scheduleEnabled}
              control={<Switch />}
              label="Enable Scheduler"
              labelPlacement="start"
              sx={{ margin: "0", mb: 2, marginRight: "20px" }}
              onChange={toggleValue}
              checked={!!scheduleEnabled}
            />
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid justifyContent="flex-end" display="flex" size={6}>
        {timeZone ? `Timezone: ${timeZone}` : ""}
      </Grid>
      <Grid size={12}>
        <Cron
          value={cronValue}
          setValue={(newValue) => {
            dispatchValues({
              type: "set_values",
              value: newValue,
            });
          }}
          defaultPeriod="year"
          readOnly={closeSelect}
        />
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "0px !important" }} size={12}>
        <div>
          <InfoOutlinedIcon style={{ marginRight: 5, verticalAlign: "bottom" }} />
          <span style={{ fontSize: 12 }}>
            Double click on a dropdown option to automatically select/unselect a periodicity
          </span>
        </div>
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "0px !important" }} size={12}>
        <div style={{ fontSize: 12, marginTop: "8px" }}>
          Enter the time in UTC format for scheduling. The time displayed here is in your selected time zone for
          reference, but only UTC will be accepted.
        </div>
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "15px !important" }} size={12}>
        {scheduleEnabled ? `Scheduled Job: ${cronValue}` : ""}
      </Grid>
      <Grid justifyContent="flex-start" display="flex" sx={{ paddingTop: "5px !important" }} size={12}>
        {scheduleEnabled ? nextRunDisplay : "Disabled or Not scheduled"}
      </Grid>
    </Grid>
  );
};

export default memo(Scheduler);
